import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'
import {
  Breadcrumb,
  breadcrumbHome,
} from '#app/shared/ui/navigation/Breadcrumb.tsx'

export default function Hero() {
  return (
    <MainContainer
      className={`
        px-4

        sm:px-6
      `}
    >
      <Breadcrumb
        items={[breadcrumbHome, { label: 'Nosotros' }]}
        className="pl-0"
      />
      <div
        className={`
          flex flex-col-reverse gap-10 pb-10 pt-2

          lg:flex-row lg:items-start lg:gap-12 lg:pb-16
        `}
      >
        <div
          className={`
            flex flex-shrink-0 flex-col

            lg:w-[565px] lg:pt-6
          `}
        >
          <p
            className={`
              mb-4 text-base font-bold uppercase tracking-wider text-primary
            `}
          >
            Nosotros
          </p>
          <h1
            className={`
              text-h3 font-bold tracking-[-0.03em] text-primary-800

              lg:text-h2 lg:leading-[52px]
            `}
          >
            La forma inteligente de acceder a un coche premium.
          </h1>
          <div
            className={`
              mt-6 flex flex-col gap-5 text-base-medium text-neutral-600
            `}
          >
            <p>
              En <span className="font-semibold">Gama Óptima</span> ofrecemos
              vehículos excepcionales, reacondicionados con los más altos
              estándares para que disfrutes una experiencia premium con una
              inversión mucho más inteligente.
            </p>
            <p>
              Seleccionamos coches con{' '}
              <span className="font-semibold">
                pocos años, bajo kilometraje y configuraciones atractivas
              </span>
              , priorizando unidades que destacan por su{' '}
              <span className="font-semibold">
                estado, procedencia y mantenimiento
              </span>
              . Después, cada vehículo pasa por un proceso de revisión y
              reacondicionamiento cuidado al detalle para presentarse en
              condiciones excelentes.
            </p>
            <p>
              La misma sensación de estrenar. La misma calidad de conducción. La
              misma experiencia premium. Pero con una decisión financiera más
              eficiente.
            </p>
          </div>
        </div>
        <div className="flex-1">
          <img
            src="/img/sobreNosotros/hero.png"
            alt="Showroom Gama Óptima"
            className={`
              h-[280px] w-full rounded-lg object-cover

              lg:h-full lg:min-h-[483px]
            `}
          />
        </div>
      </div>
    </MainContainer>
  )
}
